<template>
  <div class="pricing">
    <SubscriptionPlans />
  </div>
</template>

<script>
import SubscriptionPlans from '@/components/SubscriptionPlans.vue'

export default {
  name: 'PricingPage',
  components: {
    SubscriptionPlans
  }
}
</script>